import React, { useState, useEffect, useMemo } from 'react';
import { Chart } from 'react-chartjs-2';
import Select from 'react-select';
import PieChart from 'components/PieChart';
import _ from 'lodash';
import { Card, CardHeader, CardBody } from 'reactstrap';
import TightTable from 'components/TightTable';
import TightChart from 'components/TightChart';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import BubbleChart from 'components/BubbleChart';
import { AutoColumns } from 'components/Columns';
import { useArrayState } from 'components/CustomHooks';
import { colors } from 'helpers/chart';
import { optionizeValue, optionizeAll, getValue, getDate } from 'helpers/select';
import DetailsPieCharts from './HoldingsPieCharts';
import { toPercTable } from 'helpers/formatter';

function toDataFrame(key, dataArray) {
  const columns = Object.keys(dataArray[0]).filter((col) => col !== 'Holdings');
  const indices = dataArray.map((row) => row.Holdings);

  const data = dataArray.map((row) =>
    columns.map((column) => {
      if (column === 'Weight' && typeof row[column] === 'string' && row[column].endsWith('%')) {
        return parseFloat(row[column].replace('%', '')) / 100;
      }
      return row[column];
    }),
  );

  return {
    index: indices,
    columns: columns,
    data: data,
    index_names: ['Holdings'],
    column_names: ['Properties'],
  };
}

function Details({ data }) {
  const [assetOptions, setAssetOptions, selectedAssetOption, setSelectedAssetOption] = useArrayState({
    initialItems: [],
  });

  const [chartDataFrames, setChartDataFrames] = useState([]);

  useEffect(() => {
    if (!data) return;

    const assetKeys = Object.keys(data);
    const _assetOptions = optionizeAll(assetKeys);

    setAssetOptions(_assetOptions);
    if (_assetOptions.length > 0) {
      setSelectedAssetOption(_assetOptions[0]);
    }

    const _chartDataFrames = assetKeys.map((key) => toDataFrame(key, data[key]));
    setChartDataFrames(_chartDataFrames);
  }, [data]);

  if (assetOptions.length === 0) return;

  return (
    <>
      <div className="tw-col-start-2 tw-col-span-4">
        {assetOptions.length > 1 && (
          <>
            <div className="tw-text-left tw-font-bold">SELECT PORTFOLIO</div>
            <Select
              className="react-select mw-400px"
              value={selectedAssetOption}
              onChange={setSelectedAssetOption}
              options={assetOptions}
            />
          </>
        )}
        {selectedAssetOption && (
          <Card>
            <CardHeader tag="h4" className="mt-0 text-center">
              Details
              <div className="tw-text-sm">{selectedAssetOption.label}</div>
            </CardHeader>
            <CardBody>
              <TightTable
                suffix="summary_details"
                data={chartDataFrames[assetOptions.findIndex((v) => v.value === selectedAssetOption.value)]}
                indexName="Holdings"
                cellFormatter={(value, row, col) => {
                  return ['Weight'].includes(col) ? toPercTable(value) : value;
                }}
                useSort
              />
            </CardBody>
          </Card>
        )}
      </div>

      <DetailsPieCharts chartDataFrames={chartDataFrames} assets={assetOptions.map((v) => v.label)} />
    </>
  );
}

export default Details;
